import { theme } from "../../assets/theme";
import ImpersonationBanner from "../ImpersonationBanner";
import { SideMenu } from "../SideMenu";
import { Box, CssBaseline, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router";

const Layout = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <ImpersonationBanner />
      <Box
        sx={{
          display: "flex",
          // backgroundColor: "#F9FAFB",
          backgroundColor: "#f5f5f5",
          overflow: "hidden",
        }}
      >
        <CssBaseline />
        <SideMenu isMobile={isMobile} />
        <Outlet />
      </Box>
    </>
  );
};

export default Layout;
